<div class="navbar-scroll" data-testid="drawer-navigation">
  <div class="drawer-navigation" [class.expanded]="expanded()">
    <div class="nav-items">
      @for (navItem of navItems(); track navItem.label) {
        <app-drawer-navigation-item
          [navItem]="navItem"
          [drawerExpanded]="expanded()"
        ></app-drawer-navigation-item>
      }
    </div>
    <div class="divider divider-margin-top"></div>
    <div class="action-bar">
      @if (expanded()) {
        <div class="drawer-navigation-button" (click)="persistExpandMode()">
          <i [innerHtml]="lockStateIcon()"></i>
        </div>
      }
      <div class="drawer-navigation-button" (click)="toggleExpandState()">
        <i>{{ expandStateIcon() }}</i>
      </div>
    </div>
    <div class="divider"></div>
  </div>
</div>
